import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { GenericService } from './generic.service';

@Injectable({
  providedIn: 'root'
})
export class LogEmailMonitoramentoService extends GenericService {

  constructor(http: HttpClient) {
    super(http, 'log-email-monitoramento');
  }

  /**
   * Lista logs de email de monitoramento com filtros opcionais
   */
  listar(filtros?: any): Observable<any> {
    let params = new HttpParams();
    
    if (filtros) {
      if (filtros.monitoramento_id != null && filtros.monitoramento_id !== '') {
        params = params.set('monitoramento_id', String(filtros.monitoramento_id));
      }
      if (filtros.estacao_id) {
        params = params.set('estacao_id', filtros.estacao_id.toString());
      }
      if (filtros.grupo_emails_id) {
        params = params.set('grupo_emails_id', filtros.grupo_emails_id.toString());
      }
      if (filtros.sucesso !== undefined) {
        params = params.set('sucesso', filtros.sucesso.toString());
      }
      if (filtros.status !== undefined) {
        params = params.set('status', filtros.status.toString());
      }
      if (filtros.data_inicio) {
        params = params.set('data_inicio', filtros.data_inicio);
      }
      if (filtros.data_fim) {
        params = params.set('data_fim', filtros.data_fim);
      }
    }

    return this.http.get(`${this.url_base}/${this.prefixo}`, { params });
  }

  /**
   * Busca logs por monitoramento
   */
  listarPorMonitoramento(monitoramentoId: number): Observable<any> {
    return this.listar({ monitoramento_id: monitoramentoId });
  }

  /**
   * Busca logs por estação
   */
  listarPorEstacao(estacaoId: number): Observable<any> {
    return this.listar({ estacao_id: estacaoId });
  }

  /**
   * Parse do JSON de emails_enviados
   */
  parseEmailsEnviados(emailsEnviados: string): { to: string[], cc?: string[] } {
    try {
      return JSON.parse(emailsEnviados);
    } catch {
      return { to: [], cc: [] };
    }
  }
}

